import { useState, useEffect } from 'react';

const useActiveSkinEditor = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const checkActivationKey = () => {
      const activationKeyStored = localStorage.getItem('editorActiveKey');

      const isActivated = activationKeyStored === 'true';

      setIsActive(isActivated);
    };

    checkActivationKey();

    window.addEventListener('storage', checkActivationKey);

    return () => window.removeEventListener('storage', checkActivationKey);
  }, []);

  return isActive;
};

export default useActiveSkinEditor;
